import React, { useState, useEffect } from "react";
import PieChart, {
  Series,
  Legend,
  Label,
  Connector,
  Font,
} from "devextreme-react/pie-chart";
import Chart, {
  CommonSeriesSettings,
  Series as ChartSeries,
  ValueAxis,
  ArgumentAxis, 
  Legend as ChartLegend,
  Tooltip,
  Title as ChartTitle, 
} from "devextreme-react/chart";
import { CustomBreadcrumbs as Breadcrumbs } from "../../components";
import API from "../../api/api";
import { parsedUser } from "../../utils/GetCurrentUser"; 
import "./../DashboardCollaborators/DashboardCollaborators.css";



const renderDonutChart = (title, data, argumentField, valueField, showPercentage = false) => {

    if (!data || data.length === 0) return null;

    const customizeLabel = (pointInfo) => {
     
      if (showPercentage && pointInfo.data && pointInfo.data.percentage) {
        return `${pointInfo.argumentText}: ${pointInfo.data.percentage}`;
      }
   
      return `${pointInfo.argumentText}: ${pointInfo.valueText}`;
    };

    const customizePoint = (pointInfo) => {
    
      if (pointInfo.data && pointInfo.data.color) {
        return { color: pointInfo.data.color };
      }
      return {};
    };

    return (
      <div className="bg-white p-3 shadow" style={{ borderRadius: 15, height: '100%' }}>
        <h5 className="text-center mb-3 mt-0 chart-title">{title}</h5>
        <PieChart
          dataSource={data}
          resolveLabelOverlapping="shift"
          innerRadius={0.65}
          type="doughnut"
          customizePoint={customizePoint}
          palette="Material"
        >
          <Series argumentField={argumentField} valueField={valueField}>
            <Label
              visible={true}
              format="fixedPoint"
              customizeText={customizeLabel}
              position="columns"
            >
              <Connector visible={true} width={2}></Connector>
              <Font size={14} weight={600} color="#333" /> 
            </Label>
          </Series>

          <Legend
            verticalAlignment="bottom"
            horizontalAlignment="center"
          />
        </PieChart>
      </div>
    );
};


const DashboardCollaborators = () => {
    const user = parsedUser();

  
    const [dataGenero, setDataGenero] = useState([]);
    const [dataCategoria, setDataCategoria] = useState([]);
    const [dataTipoVivienda, setDataTipoVivienda] = useState([]);
    const [dataDivisionPersonal, setDataDivisionPersonal] = useState([]);
    const [dataTipoColaborador, setDataTipoColaborador] = useState([]);
    const [dataAreaPersonal, setDataAreaPersonal] = useState([]);
    const [dataIngresos, setDataIngresos] = useState([]);
    const [loading, setLoading] = useState(true);

    const getDataDashboard = async () => {
        setLoading(true);
        try {
            const query = `Token=${user.Token}&IdUser=${user.IdUser}`;
          
            const response = await API.getAction(
                `api/OcupacionProcesos/DashboardColaboradores?${query}`,
                null
            );

            if (response.data && response.data.length > 0) {
                let firstLevel = JSON.parse(response.data[0].JSONData);
                const dashboardData = firstLevel.DashboardData;
                
                // Función para extraer data de un ItemTitle específico
                const extractData = (title) => {
                    const group = dashboardData.find(g => g.ItemTitle === title);
                    return (group && group.GroupItems.length > 0) ? group.GroupItems[0].ItemData : [];
                };
                
                
                // Género
                setDataGenero(extractData('Género').map(item => ({ 
                    category: item.Kpi, 
                    value: item.Valor, 
                    color: item.Color 
                })));
                
                // Categoría
                setDataCategoria(extractData('Categoría').map(item => ({ 
                    category: item.Kpi, 
                    value: item.Valor, 
                    color: item.Color 
                })));
                
                // Tipo Vivienda
                setDataTipoVivienda(extractData('Tipo Vivienda').map(item => ({ 
                    category: item.Kpi, 
                    value: item.Valor, 
                    color: item.Color 
                })));

                // División de Personal
                setDataDivisionPersonal(extractData('División de Personal').map(item => ({ 
                    category: item.Kpi, 
                    value: item.Valor, 
                    color: item.Color 
                })));
                
                // Tipo Colaborador (Asumiendo que tiene porcentaje)
                setDataTipoColaborador(extractData('Tipo Colaborador').map(item => ({ 
                    category: item.Kpi, 
                    value: item.Valor, 
                    percentage: item.Percentage, 
                    color: item.Color 
                })));

                // Área de Personal (Asumiendo que tiene porcentaje)
                setDataAreaPersonal(extractData('Área de Personal').map(item => ({ 
                    category: item.Kpi, 
                    value: item.Valor, 
                    percentage: item.Percentage,
                    color: item.Color 
                })));
                
                setDataIngresos(extractData('Ingresos Últimos 12 Meses'));

            } else {
                // Manejar respuesta vacía si es necesario
            }
        } catch (error) {
            console.error("❌ Dashboard Colaboradores Error:", error);
        }
    };

    useEffect(() => {
        if (user && user.Token && user.IdUser) {
            getDataDashboard();
        }
    }, [user.Token, user.IdUser]);
    

    return (
        <>
            <Breadcrumbs pathTitle={"Dashboard Colaboradores"} />

            <div className="container-fluid px-4">
                <div className="row">
                    {/* Fila de Gráficos de Dona Superiores */}
                    <div className="col-xl-3 col-lg-6 col-md-6 mb-4">
                        {renderDonutChart("Género", dataGenero, "category", "value")}
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 mb-4">
                        {renderDonutChart("Categoría", dataCategoria, "category", "value")}
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 mb-4">
                        {renderDonutChart("Tipo Vivienda", dataTipoVivienda, "category", "value")}
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 mb-4">
                        {renderDonutChart("División de Personal", dataDivisionPersonal, "category", "value")}
                    </div>
                </div>

                {/* Fila de Gráficos de Dona Inferiores y Barras */}
                <div className="row">
                    <div className="col-xl-4 col-lg-6 mb-4">
                        {renderDonutChart("Tipo Colaborador", dataTipoColaborador, "category", "value", true)} 
                    </div>
                    <div className="col-xl-4 col-lg-6 mb-4">
                        {renderDonutChart("Área de Personal", dataAreaPersonal, "category", "value", true)}
                    </div>
                    
                    {/* Gráfico de Barras - Ingresos Últimos 12 Meses */}
                    <div className="col-xl-4 col-lg-12 mb-4">
                        <div className="bg-white p-3 shadow" style={{ borderRadius: 15, height: '400px' }}>
                            <h5 className="text-center mb-3 mt-0 chart-title">Ingresos Últimos 12 Meses</h5>
                            <Chart
                                dataSource={dataIngresos}
                                rotated={false}
                                // Se asume que el argumento es 'month' y los valores 'entradas'/'salidas'
                            >
                                <CommonSeriesSettings
                                    argumentField="month"
                                    type="bar"
                                    hoverMode="allArgumentPoints"
                                    selectionMode="allArgumentPoints"
                                />
                                <ChartSeries
                                    valueField="entradas"
                                    name="Entradas"
                                    color="#8bc34a"
                                />
                                <ChartSeries
                                    valueField="salidas"
                                    name="Salidas"
                                    color="#e3646f"
                                />
                                <ArgumentAxis /> 
                                <ValueAxis>
                                    <Label format="decimal" />
                                </ValueAxis>
                                <ChartLegend
                                    verticalAlignment="bottom"
                                    horizontalAlignment="center"
                                />
                                <Tooltip enabled={true} />
                                <ChartTitle text="Ingresos Últimos 12 Meses" /> 
                            </Chart>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DashboardCollaborators;